import styled from 'styled-components';
import { ReactComponent as Arrow } from 'styles/icons/arrow.svg';
import { color, typography } from 'styles/settings';
import { normalize, withModifiers } from 'utils/styles';

export const PaginationContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1;
`;

export const PagesContainer = styled.div`
  align-items: center;
  cursor: pointer;
  justify-content: flex-start;
  margin: 5px;
`;

export const Page = styled.div`
  color: ${color.neutral.grayDark};
  ${typography.font.medium};
  font-size: 16px;
  padding: 2px;
  ${withModifiers('current')`
    color: ${color.brand.gold};
    ${typography.font.semiBold};
  `};
`;

export const PerPageContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin: 5px;
`;

export const PerPage = styled.span`
  color: ${color.neutral.grayDark};
  height: 20px;
  padding-right: 10px;
  padding-left: 10px;
  border-right-color: ${color.neutral.grayLight};
  ${typography.font.medium};

  /* stylelint-disable */

  ${withModifiers('selected')`
    ${typography.font.semiBold};
    color: ${color.brand.gold};
  `};

  /* stylelint-enable */
`;

export const ArrowIcon = styled(Arrow)`
  color: ${color.brand.gold};
  height: ${normalize('14px')};
  width: ${normalize('14px')};
  padding: ${normalize('4px')};
  transform: rotate(270deg);
  ${withModifiers('$right')`
    transform: rotate(90deg);
  `};
`;
